export const getEcReturnDisplayPrice = (
  price: number,
  isAuction = false,
  currentHighestAmount?: number | null,
): number => {
  return isAuction ? currentHighestAmount ?? price : price;
};
